import React, {useContext, useEffect} from "react";
import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import ContentBody from "../common/content-body/ContentBody";
import ExpiredRaFilter from "./expired-ra-filter/ExpiredRaFilter";
import ResultsList from "./results-list/ResultsList";
import RaFilter from "./ra-filter/RaFilter";

const RaSearch = ({type}: {type: "general" | "expired"}) => {
    const {t} = useTranslation(['network', 'translation']);

    let title = '';

    switch (type) {
        case 'general':
            title = t("raSearch.header.general");
            break;
        case 'expired':
            title = t("raSearch.header.expired");
            break;
    }

    useEffect(() => { },[]);

    return (
        <>
            <SectionHeader title={title} />

            <ContentBody>
                {
                    type === 'general' &&
                    <RaFilter />
                }

                {
                    // aggiungere verifica degli user
                    type === 'expired' &&
                    <ExpiredRaFilter />
                }


                <ResultsList type={type}/>

            </ContentBody>
        </>
    )
}

export default RaSearch;